import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { InvoiceProductStore, InvoiceProductDTO } from '../types';

const initialState = {
    products: [] as InvoiceProductDTO[],
    selectedProduct: null as InvoiceProductDTO | null,
    isLoading: false,
    isSubmitting: false,
    error: null as string | null,
    showInactive: false
};

export const useInvoiceProductStore = create<InvoiceProductStore>()(
    devtools(
        (set) => ({
            ...initialState,
            setProducts: (products) => set({ products }),
            setSelectedProduct: (product) => set({ selectedProduct: product }),
            setLoading: (loading) => set({ isLoading: loading }),
            setSubmitting: (submitting) => set({ isSubmitting: submitting }),
            setError: (error) => set({ error }),
            setShowInactive: (show) => set({ showInactive: show }),
            reset: () => set(initialState)
        }),
        { name: 'invoice-product-store' }
    )
);
